export const iOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false );
export const rootURL = window.location.hostname.indexOf('tombrasweb.com') !== -1 ? 'https://freightlinertrucks-dev.azurewebsites.net/umbraco/api' : '/umbraco/api';
export const mapURL = iOS ? 'http://maps.apple.com/?daddr=' : 'https://www.google.com/maps/?q=';
export const googleMapsKey = 'AIzaSyDYwYS7gcKir2F8RwxwnmagvKBcCtfPRp4';
export const mapStyles = [
	{
		featureType: "all",
		stylers: [
			{ saturation: -80 }
		]
	},{
		featureType: "road.arterial",
		elementType: "geometry",
		stylers: [
			{ hue: "#00ffee" },
			{ saturation: 50 }
		]
	},{
		featureType: "poi.business",
		elementType: "labels",
		stylers: [
			{ visibility: "off" }
		]
	}
];
export const jwpKey = 'TtV5iMjD1ORmFr/yZP1lV7lbxWn69lBGpwxo9Pz2IV13Jkn4';
export const jwpPlayerId = 'sHGOoMEW';